export const MENU_REFRESH_QUERY = '_menuRefresh'

export function cleanMenuRefreshQuery(query = {}) {
  const nextQuery = Object.assign({}, query)
  delete nextQuery[MENU_REFRESH_QUERY]
  return nextQuery
}

export function withMenuRefreshQuery(query = {}, refresh = false) {
  const nextQuery = cleanMenuRefreshQuery(query)
  if (refresh) {
    nextQuery[MENU_REFRESH_QUERY] = Date.now()
  }
  return nextQuery
}

export function cleanMenuRefreshFullPath(fullPath = '') {
  if (!fullPath || fullPath.indexOf(MENU_REFRESH_QUERY) === -1) return fullPath
  const cleanPart = (value = '') => {
    const queryIndex = value.indexOf('?')
    if (queryIndex < 0) return value

    const path = value.slice(0, queryIndex)
    const query = value.slice(queryIndex + 1)
    const params = query
      .split('&')
      .filter(item => item && item.split('=')[0] !== MENU_REFRESH_QUERY)
    return `${path}${params.length ? `?${params.join('&')}` : ''}`
  }
  const hashIndex = fullPath.indexOf('#')
  if (hashIndex < 0) return cleanPart(fullPath)
  return `${cleanPart(fullPath.slice(0, hashIndex))}#${cleanPart(fullPath.slice(hashIndex + 1))}`
}

export function getMenuRouteValue(route = {}) {
  return (route.query && route.query.src) || cleanMenuRefreshFullPath(route.fullPath || '')
}

export function hasOpenedTag(tagList = [], value = '') {
  return tagList.some(tag => cleanMenuRefreshFullPath(tag.value) === value)
}
